import React from 'react';

import Section from "../../Section";
import LibTile from "../../LibTile";

const libs = [
  { title: "StateCalc", desc: "A simple state based calculator that mimics functionality of common desk or system calculators." },
  { title: "StringCombo", desc: "A javascript libary to generate combinations of css selectors. Used for dynamic css generation." },
  { title: "NaiveNLP", desc: "Extremely naive nlp processor. Uses other nlp packages to ATTEMPT to simplify an input string for further processing." },
  { title: "RegReplacer", desc: "A library to facilitate regex matching, match/capture retrieval and string replacement." },
  { title: "ParamTree", desc: "Library to sort functions into object trees by their parameter lengths and names." },
  { title: "VariableStore", desc: "A variable data store using to privately store variables using a map like interface."},
  { title: "Celebs", desc: "Package built to access the Pantheon Fame 1.0 database." },
  { title: "EasyCrypt", desc: "A simple bi-directional salting and encryption system designed for securing authentication tokens." },
  { title: "DistanceSearch", desc: "A library to search through json objects using distance comparators like Dice Distance or the Levenshtein algorithm." }
]

export default function Libraries(props) {
  return <Section>
    <a name="libraries" />
    <h1 className="mdl-typography--display-1-color-contrast">Libraries</h1>
    <div className="mdl-grid portfolio-max-width">
      {
        libs.map((e, i) => <LibTile key={i} {...e} />)
      }
    </div>
  </Section>
}



// WEBPACK FOOTER //
// ./src/Pages/Libraries/Libraries.js